<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card class="mb-5" title="Filter Permohonan">
        <!-- Filter -->
          <div class="vx-row mb-base">
            <vs-input v-model="filter.cari" icon-pack="feather" icon="icon-search" class="vx-col w-full md:w-1/2 mt-5"
              placeholder="Cari no pendaftaran atau nama pemohon"
            />
            <vs-select v-model="filter.kecamatan" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Kecamatan" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsKecamatan" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
            <vs-select v-model="filter.kelurahan" :disabled="!filter.kecamatan" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Kelurahan" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsKelurahan" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
            <vs-select v-model="filter.bidang" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Bidang" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsBidang" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
            <vs-select v-model="filter.izin" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Izin" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsIzin" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
            <vs-select v-model="filter.peruntukan" :disabled="!filter.izin" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Peruntukan" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsPeruntukan" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
            <vs-select v-model="filter.posisi" class="vx-col w-full md:w-1/4 mt-5" @change="loadItems()">
              <vs-select-item value="" text="Semua Posisi Berkas" class="w-full" />
              <vs-select-item v-for="(item,index) in itemsPosisi" :key="index"
                :value="item.value" :text="item.text" class="w-full"
              />
            </vs-select>
          </div>
        <!-- End Filter -->
      </vx-card>
    </div>
    <div class="w-full vx-col">
      <vx-card title="Data Permohonan LAPERON" class="mb-base">
        <global-wrapper :loading="loading" :loadingType="'avatar-three-line'" :loadingList="4" :scrollable="true">
          <global-table @reloadData="handleOnReloadData($event)" :currentPage="items.current_page" :totalPage="items.last_page">
            <template #thead>
              <global-th width="20px">No.</global-th>
              <global-th>Tgl & No Pendaftaran</global-th>
              <global-th>Nama Pemohon</global-th>
              <global-th>Nama Izin</global-th>
              <global-th>Lokasi Izin</global-th>
              <global-th>Posisi Berkas</global-th>
              <global-th>Action</global-th>
            </template>
            <template v-if="items.total != 0" #tbody>
              <global-tr v-for="(item, index) in items.data" :key="index">
                <global-td>{{ getRowNumber(index) }}</global-td>
                <global-td>{{ item.no_pendaftaran}} <br/> {{item.tgl_daftar}} </global-td>
                <global-td>{{ item.nama_pemohon}}</global-td>
                <global-td>{{ item.inisial}}</global-td>
                <global-td>{{ 'Kel. ' + item.nama_kelurahan + ', Kec. ' + item.nama_kecamatan}}</global-td>
                <global-td>{{ item.nama_posisi}}</global-td>
                <global-td>
                  <vs-button @click="showDetail(item)" icon-pack="feather" icon="icon-external-link" icon-after> Lihat Detail </vs-button>
                </global-td>
              </global-tr>
            </template>
            <template v-else #tbody>
              <global-tr>
                <global-td colspan="7" class="text-center">Data Kosong / Tidak Ditemukan</global-td>
              </global-tr>
            </template>
          </global-table>
        </global-wrapper>
      </vx-card>
    </div>
    <modal-detail :active.sync="isActiveModal" :permohonan="selectedPermohonan" />
  </div>
</template>

<script>
import ModalDetail from "./ModalDetail.vue";
import _ from "lodash";

export default {
  components: {
    ModalDetail
  },
  data () {
    return {
      loading: true,
      items: [],
      itemsKecamatan: [],
      itemsKelurahan: [],
      itemsBidang: [],
      itemsIzin: [],
      itemsPeruntukan: [],
      itemsPosisi: [],
      selectedPermohonan: {},
      filter: {
        cari: '',
        bidang: '',
        izin: '',
        posisi: '',
        kecamatan: '',
        kelurahan: '',
        peruntukan: ''
      },
      pagination: {
        currentPage: 1,
        perPage: 10
      },
      isActiveModal: false
    }
  },
  watch: {
    'filter.kecamatan': {
      handler (newValue) {
        this.filter.kelurahan = ''
        if (newValue !== '') {
          this.loadItemsKelurahan()
        }
      }
    },
    'filter.bidang': {
      handler (newValue) {
        this.filter.izin = ''
        this.filter.peruntukan = ''
        if (newValue !== '') {
          this.loadItemsIzin()
        }
      }
    },
    'filter.izin': {
      handler (newValue) {
        this.filter.peruntukan = ''
        if (newValue !== '') {
          this.loadItemsPeruntukan()
        }
      }
    },
    'filter.cari': _.debounce(function (query) {
      this.loadItems(query);
    }, 500),
  },
  mounted() {
    this.loadItems()
    this.loadItemsKecamatan()
    this.loadItemsBidang()
    this.loadItemsIzin()
    this.loadItemsPeruntukan()
    this.loadItemsPosisi()
  },
  methods: {
    showDetail(item){
      this.selectedPermohonan = item;
      this.isActiveModal = true;
    },
    async loadItems () {
      this.loading = true;
      const res = await this.$http.get('/info-berkas/data', {
        params: {
          page: this.pagination.currentPage,
          filter_cari: this.filter.cari,
          filter_bidang: this.filter.bidang,
          filter_izin: this.filter.izin,
          filter_posisi: this.filter.posisi,
          filter_kecamatan: this.filter.kecamatan,
          filter_kelurahan: this.filter.kelurahan,
          filter_peruntukan: this.filter.peruntukan
        }
      })
      this.items = res.data.data;
      this.loading = false;
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.loadItems();
    },
    async loadItemsKecamatan () {
      const res = await this.$http.get('/info-berkas/option/kecamatan')
      this.itemsKecamatan = res.data.data
    },
    async loadItemsKelurahan () {
      const res = await this.$http.get('/info-berkas/option/kelurahan', { params: { kecamatan: this.filter.kecamatan } })
      this.itemsKelurahan = res.data.data
    },
    async loadItemsBidang () {
      const res = await this.$http.get('/info-berkas/option/bidang')
      this.itemsBidang = res.data.data
    },
    async loadItemsIzin () {
      const res = await this.$http.get('/info-berkas/option/izin', { params: { bidang: this.filter.bidang }})
      this.itemsIzin = res.data.data
    },
    async loadItemsPeruntukan () {
      const res = await this.$http.get('/info-berkas/option/peruntukan', { params: { izin: this.filter.izin }});
      this.itemsPeruntukan = res.data.data
    },
    async loadItemsPosisi () {
      const res = await this.$http.get('/info-berkas/option/posisi')
      this.itemsPosisi = res.data.data
    },
    getRowNumber(index){
      return ((this.pagination.currentPage - 1) * this.pagination.perPage) + index + 1;
    }
  }
}
</script>